import fetch from 'lib/decorated-fetch'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'

import getUrl from 'lib/url'

interface ICarItem {
  text: string
  value: number
}

export const fetchList = (params: any) => {
  const BASE_URL = '/motor/car_page/v3/get_picture/?version_code=445&'

  const { category, seriesId, offset, color, carId } = params

  return fetch(
    getUrl(
      `${BASE_URL}category=${category}&car_id=${carId}&series_id=${seriesId}&offset=${offset}&color=${color}`
    )
  ).then(res => {
    const { list = [] } = res.data
    res.data.list = list.filter((item: any) => !item.info.title)
    return res.data
  })
}

export const fetchCategoryList = (seriesId: string) => {
  const BASE_URL = '/motor/car_page/v3/get_picture_head/'

  return fetch(getUrl(`${BASE_URL}?series_id=${seriesId}`)).then(
    res => res.data.category_list
  )
}

interface IGetImageCount {
  seriesId: string | number
  category: string
  carId?: string | number
  color?: string
}
export function fetchCategoryImageCount(params: IGetImageCount) {
  const { seriesId, carId, ...opt } = params
  return fetch(
    getUrl(
      `/cloud/api/invoke/get_image_count?${serializeObject({
        ...opt,
        series_id: seriesId,
        car_id: carId,
      })}`
    )
  )
}

export const fetchSeriesInfo = (seriesId: string, req?: any) => {
  return fetch(
    getUrl(
      `/motor/car_page/m/v1/get_head/?series_id=${seriesId}`,
      'motor.car_page.api'
    ),
    { req }
  ).then(({ concern_obj: { brand_name, name } }) => ({ brand_name, name }))
}

export const fetchCar = ({ seriesId }: any) => {
  return fetch(
    getUrl(
      `/motor/car_page/m/v2/series_all_json/?series_id=${seriesId}&req_type=online`
    )
  ).then(({ data = [] }) => {
    const list: ICarItem[] = []
    data.forEach(({ info: { car_id, name } }: any) => {
      if (car_id) {
        list.push({
          text: name,
          value: car_id,
        })
      }
    })
    return list
  })
}

export const fetchCityName = () =>
  fetch(getUrl('/motor/car_service/open_api/get_ip_city/')).then(
    ({ data: { city_name } }) => city_name
  )

export default {
  fetchList,
  fetchCar,
  fetchSeriesInfo,
  fetchCategoryList,
}
